var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadIcon = function SvgUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28334A",
    fillRule: "evenodd",
    d: "M22.625 14.602c.76 0 1.375.615 1.375 1.376v5.45A2.574 2.574 0 0 1 21.428 24H2.573A2.575 2.575 0 0 1 0 21.428v-5.45a1.377 1.377 0 0 1 2.752 0v5.271h18.497v-5.271c0-.76.615-1.376 1.376-1.376M12 0c.366 0 .716.145.973.404l5.643 5.643a1.375 1.375 0 0 1-1.944 1.945l-3.25-3.248v10.54a1.375 1.375 0 1 1-2.75.001V4.65l-3.34 3.341a1.378 1.378 0 0 1-2.35-.973c0-.352.134-.705.403-.973L11.028.402C11.286.145 11.635 0 12 0"
  })));
};
export default SvgUploadIcon;